<template>
    <div>
        <div class="form-group row">
            <label for="single-symbol-fill-color" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Kolor wypełnienia</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <color-picker v-model="fillColor" id="single-symbol-fill-color" />
            </div>
        </div>
        <div class="row" v-show="styleDataErrors.incorrectFileFormat" id="incorrect-file-format-description">
          <small :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
            Wybrano nieprawidłowy format pliku. Dopuszczalny format pliku to png.
          </small>
        </div>
        <div class="form-group row">
            <label for="single-symbol-design" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Deseń</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
              <b-form-file v-model="designFileBuffer" accept="image/png" :class="{ 'is-invalid': styleDataErrors.incorrectFileFormat }" :aria-invalid="styleDataErrors.incorrectFileFormat" :aria-describedby="styleDataErrors.incorrectFileFormat ? 'incorrect-file-format-description' : ''" v-on:change="fileChanged"></b-form-file>
              <small class="form-text text-muted" v-if="designFileSaved">
                Używany <a :href="design" download="obraz.png">plik</a>. <b-btn variant="outline-primary" size="sm" @click="setFileValue(null, false)">Usuń</b-btn>
              </small>
            </div>
        </div>
        <div class="form-group row">
            <label for="single-symbol-stroke-style" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Styl obrysu</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <b-form-select v-model="strokeStyle" :options="strokeStylesList" id="single-symbol-stroke-style"></b-form-select>                 
            </div>
        </div>
        <div class="row" v-show="styleDataErrors.strokeSizeEmpty" id="stroke-size-empty-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Należy podać szerokość obrysu.
            </small>
        </div>
        <div class="row" v-show="styleDataErrors.strokeSizeNotInRange" id="stroke-size-range-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Szerokość obrysu powinna zawierać się w przedziale od 1 do 255.
            </small>
        </div>
        <div class="form-group row">
            <label for="single-symbol-stroke-size" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Szerokość obrysu</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <b-form-input v-model="strokeSize" type="number" id="single-symbol-stroke-size" min="1" max="255" class="form-control" :class="{ 'is-invalid': styleDataErrors.strokeSizeEmpty || styleDataErrors.strokeSizeNotInRange }" :aria-required="strokeStyle !== null" :aria-invalid="styleDataErrors.strokeSizeEmpty || styleDataErrors.strokeSizeNotInRange" :aria-describedby="styleDataErrors.strokeSizeEmpty ? 'stroke-size-empty-description' : (styleDataErrors.strokeSizeNotInRange ? 'stroke-size-range-description' : '')"></b-form-input>             
            </div>
        </div>
        <div class="form-group row">
            <label for="single-symbol-stroke-color" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Kolor obrysu</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <color-picker v-model="strokeColor" id="single-symbol-stroke-color" />
            </div>
        </div>
    </div>
</template>

<script>
import ColorPicker from "../../ColorPicker.vue";
import { getBase64Image } from '../../../api/HelperFunctions';
import LayerStyleStore from "../store/LayerStyleStore";

export default {
  name: "FormLayerStylePolygonSingleSymbol",
  props: {
    size: String
  },
  data() {
    return {
      fillColor: { r: 255, g: 255, b: 0, a: 1 },
      design: null,
      designFileSaved: false,
      designFileBuffer: null,
      strokeStyle: [1],
      strokeSize: 3,
      strokeColor: { r: 255, g: 0, b: 255, a: 1 },
      incorrectFileFormat: false,
      strokeStylesList: [
        { text: "Wybierz", value: null },
        { text: "Kreskowany", value: [4, 4] },
        { text: "Kropkowany", value: [1, 1] },
        { text: "Ciągły", value: [1] }
      ],
      styleDataErrors: {
        strokeSizeEmpty: false,
        strokeSizeNotInRange: false,
        incorrectFileFormat: false
      }
    };
  },
  mounted() {
    let store = new LayerStyleStore();
    const initialValue = store.getPolygonSingleSymbol(); 
    if (initialValue != null && initialValue.reguly !== undefined && initialValue.reguly.length !== 0) {
      this.fillColor = initialValue.reguly[0].sygnatura.wypelnienie.kolor;
      this.design = initialValue.reguly[0].sygnatura.wypelnienie.obraz;
      this.designFileSaved = this.design != null && this.design.length > 0;
      this.strokeStyle = initialValue.reguly[0].sygnatura.obrys.kreskowanie;
      this.strokeSize = initialValue.reguly[0].sygnatura.obrys.szerokosc;
      this.strokeColor = initialValue.reguly[0].sygnatura.obrys.kolor;
    }
  },
  methods: {
    updateValue() {
      let store = new LayerStyleStore();
      store.setPolygonSingleSymbol({
        reguly: [
        {
          filtr: null,
          sygnatura: {
            obrys: {
              kolor: this.strokeColor,
              kreskowanie: this.strokeStyle,
              szerokosc: this.strokeSize ? parseInt(this.strokeSize) : null
            },
            wypelnienie: {
              kolor: this.fillColor,
              obraz: this.design
            }
          }
        }
      ]});
      this.$emit('updated');
    },
    validate() {
      this.updateValue();
      var vm = this;
      Object.keys(this.styleDataErrors).forEach(
        x => (vm.styleDataErrors[x] = false)
      );
      if(this.designFileBuffer !== undefined && this.designFileBuffer !== null && this.designFileBuffer.type !== 'image/png'){
        this.styleDataErrors.incorrectFileFormat = true;
      }
      if (this.strokeStyle !== null) {
        if (this.strokeSize === "") {
          this.styleDataErrors.strokeSizeEmpty = true;
        } else if (this.strokeSize < 1 || this.strokeSize > 255) {
          this.styleDataErrors.strokeSizeNotInRange = true;
        }
      }
      return Object.keys(this.styleDataErrors).some(
        x => vm.styleDataErrors[x] === true
      );
    },
    fileChanged(e) {
      let files = e.target.files;
      let vm = this;
      if (files.length) {
        if(files[0].type !== 'image/png'){
          this.setFileValue(null, true);
        } else {
          getBase64Image(files[0]).then(result => {
            vm.setFileValue(result, false);
          }, error => {
            vm.setFileValue(null, true);
          });
        }
      } else {
        this.setFileValue(null, false);
      }
    },
    setFileValue(file, error){
      this.designFileSaved = false;
      this.design = file;
      this.styleDataErrors.incorrectFileFormat = error;
      this.updateValue();
    }
  },
  components: {
    ColorPicker
  }
};
</script>